import { forwardRef } from 'react'
import Select, { components } from 'react-select'

import { isPresent } from 'utils'

import { OptionImage, OptionInner, Root } from './SelectInput.style'
import DropdownIndicatorSvg from './svg/caret.svg'

const DropdownIndicator = () => <DropdownIndicatorSvg width={16} height={9} />

const SingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      <OptionInner>
        {isPresent(props.data.image) && <OptionImage src={props.data.image} alt={props.data.label} />}
        <span>{props.data.label}</span>
      </OptionInner>
    </components.SingleValue>
  )
}

const Option = (props) => {
  return (
    <components.Option {...props}>
      <OptionInner>
        {isPresent(props.data.image) && <OptionImage src={props.data.image} alt={props.data.label} />}
        <span>{props.data.label}</span>
      </OptionInner>
    </components.Option>
  )
}

const customStyles = {
  valueContainer: (provided) => ({
    ...provided,
    padding: '1em 0',
  }),
  control: (provided) => ({
    ...provided,
    borderWidth: 0,
    outline: 0,
    borderRadius: 0,
    boxShadow: 'none',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'var(--color-gold-black)',
    fontFamily: 'var(--font-nhu)',
    fontWeight: 300,
    letterSpacing: '0.028em',
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: 'var(--font-nhu)',
    fontWeight: 300,
    letterSpacing: '0.028em',
    color: state.isSelected ? 'var(--color-white)' : 'var(--color-gold-black)',
    backgroundColor: state.isSelected ? 'var(--color-gold)' : 'var(--color-white)',
  }),
  menu: (provided) => ({
    ...provided,
    borderWidth: 0,
    outline: 0,
    borderRadius: 0,
    boxShadow: '0 4px 11px hsl(0deg 0% 0% / 10%)',
    marginTop: 0,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
  }),
}

const SelectInput = forwardRef(({ error, ...props }, ref) => {
  // Dynamic styles
  customStyles.container = (provided) => ({
    ...provided,
    borderRadius: 0,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: error ? 'var(--color-danger)' : 'var(--color-black)',
  })
  customStyles.placeholder = (provided) => ({
    ...provided,
    color: error ? 'var(--color-danger)' : 'var(--color-gold-black)',
    fontFamily: 'var(--font-nhu)',
    fontWeight: 300,
    letterSpacing: '0.028em',
  })

  return (
    <Root>
      <Select ref={ref} {...props} styles={customStyles} components={{ SingleValue, Option, DropdownIndicator }} />
    </Root>
  )
})

SelectInput.displayName = 'SelectInput'

export default SelectInput
